import React, { useRef } from "react";
import { Form, Ref } from "semantic-ui-react";
import cn from "classnames";

import "./validatedField.scss";
import ValidationErrorPrompt from "../../../../components/forms/ValidationErrorPrompt";
import LabelWithInfoTooltip from "../../../../components/labelWithInfoTooltip/labelWithInfoTooltip";
import { type ValidatedFieldProps } from "./models";

export const ValidatedField = (props: ValidatedFieldProps) => {
  const { children, label, tooltip, error, errorPosition, markAsRequired, pushdown, withoutErrorMessage, showError } =
    props;
  const r = useRef<HTMLElement>(null);
  const isInErrorState = !!error && showError;
  const labelClasses = {
    "validated-field-label": true,
    error: isInErrorState,
    "required-asterisk": markAsRequired,
  };

  return (
    <>
      {label && !tooltip && <label className={cn(labelClasses)}>{label}</label>}
      {label && tooltip && (
        <LabelWithInfoTooltip label={label} width={tooltip.width} info={tooltip.info} labelClass={cn(labelClasses)} />
      )}
      <Ref innerRef={r}>
        <Form.Field
          error={isInErrorState}
          className={cn("validated-field", errorPosition, {
            pushdown,
          })}
        >
          {children}
          {!withoutErrorMessage && isInErrorState && (
            <ValidationErrorPrompt errorPosition={errorPosition ?? "right"} text={error} innerRef={r} />
          )}
        </Form.Field>
      </Ref>
    </>
  );
};

export default React.memo(ValidatedField);
